import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import isTokenValid from "../api/isTokenValid";

export function RouteLogin({ children }) {
  const [isValidToken, setIsValidToken] = useState(null); // Inicializando como null para carregar primeiro
  const [loading, setLoading] = useState(true);  // Controle de carregamento

  useEffect(() => {
    const checkTokenValidity = async () => {
      const result = await isTokenValid();
      setIsValidToken(result);  // Define o estado após a verificação
      setLoading(false);  // Finaliza o carregamento
    };

    checkTokenValidity();
  }, []);  // Verifica uma vez ao carregar o componente

  if (loading) {
    return <div>Carregando...</div>; // Exibe enquanto o token está sendo verificado
  }

  if (isValidToken) {
    return <Navigate to="/admin" replace />; // Se token for válido, redireciona para o admin
  }

  return children;  // Caso contrário, renderiza o conteúdo
}
